<script setup lang="ts">
import { ToastClose, type ToastCloseProps } from 'radix-vue'
import { type HTMLAttributes, computed } from 'vue'

const props = defineProps<ToastCloseProps & {
	class?: HTMLAttributes['class']
}>()

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props

	return delegated
})
</script>

<template>
	<toast-close v-bind="delegatedProps" :class="cn('absolute right-1 top-1 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-1 group-hover:opacity-100', props.class)">
		<i-ph-x-bold class="size-4" />
	</toast-close>
</template>
